// Picks the one Actionstep matter a file number refers to, or refuses.
//
// The matter search is a wildcard match, so a file number can return several matters or a
// near-miss - "24-100" also matches "24-1001". Writing a file note onto the wrong client's
// file is a serious error in a legal practice, and far worse than asking someone to file it
// by hand, so this only ever resolves on an exact and unambiguous match.
//
// A plain function so the decision can be tested directly rather than only by submitting a
// real request against a real system.
export function matchMatterByFileNumber(results, fileNumber) {
  const wanted = String(fileNumber || "").trim().toLowerCase();
  if (!wanted) return { matter: null, reason: "no-file-number", candidates: [] };

  const exact = (results || []).filter(
    (matter) => String(matter?.client?.fileNumber || "").trim().toLowerCase() === wanted,
  );

  if (exact.length === 0) return { matter: null, reason: "no-match", candidates: [] };
  if (exact.length > 1) return { matter: null, reason: "ambiguous", candidates: exact };
  return { matter: exact[0], reason: "ok", candidates: exact };
}
